import { darken } from "polished";
import ReactInputMask from "react-input-mask";
import styled from "styled-components";
// import '../../index.scss'
import "../../styles/sass/Pages/_newDesign.scss";

export const Container = styled.div`
	width: 50%;
	height: 100%;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
	background: #23242f;

	@media only screen and (max-device-width: 900px) {
		width: 100%;
		background: #13141b;
	}

	@media only screen and (max-device-width: 380px) {
		height: 40rem;
	}
`;

export const Content = styled.section`
	width: 27rem;
	height: 100%;
	background: #23242f;
	z-index: 1000;

	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	font-family: "MetropolisRegular";

	@media only screen and (max-device-width: 900px) {
		width: 100%;
		background: #13141b;
		position: relative;
		max-width: 23rem;
		height: 90%;
		justify-content: flex-start;
	}

	@media only screen and (max-device-width: 380px) {
		width: 85%;
	}

	form {
		opacity: 1;
		width: 100%;
		max-width: 27rem;
		padding-top: 16px;
	}
`;

export const FormGroupInput = styled.div`
	position: relative;
	padding-top: 1.5rem;
	width: 100%;

	input {
		font-size: 16px;
		color: #ffffff;
		padding: 16px;
		border: solid 2px #353546;
		height: 56px;
		width: 100%;
		outline: none;
		z-index: 1;
		background-color: transparent;
		border-radius: 8px;
		font-family: "Metropolislight";
	}

	label {
		font-family: var(--font-family-metropolis-semi-bold);
		margin-bottom: 4px;
	}
`;

export const Title = styled.div`
	color: #ffffff;
	font-size: 24px;
	font-family: var(--font-family-metropolis-semi-bold);
	width: 100%;
`;

export const Subtitle = styled.span`
	font-size: 16px;
	color: #ffffff;
	font-family: "MetropolisRegular";
	padding-top: 0.5rem;
`;

export const Label = styled.label`
	font-size: 12px;
	color: #ffffff;
`;

export const InputPhone = styled(ReactInputMask)`
	background: #00000000;
	font-family: "MetropolisRegular";
	color: #ffffff;
	border-radius: 8px;
	font-size: 16px;
	padding: 16px;
	width: 27rem;
	height: 56px;

	border: solid 2px #353546;

	&:focus {
		border: solid 2px #01e59b;
	}
`;

export const FormSubmit = styled.div`
	margin-top: 2.5rem;
`;

export const Group = styled.div`
	cursor: pointer;
	display: flex;
	width: 25.5rem;
	align-items: center;
	justify-content: space-between;

	span {
		font-size: 16px;
		color: #ffff;
	}

	@media only screen and (max-device-width: 900px) {
		align-items: flex-start;
		width: 100%;

		input {
			margin-top: 5px;
			margin-right: 0.7rem;
		}
	}
`;

export const ButtonTerms = styled.a`
	border: none;
	font-family: var(--font-family-metropolis-semi-bold);
	outline: none !important;
	font-size: 16px;
	color: #01e59b;

	:hover {
		color: #01e59b;
	}
`;
